var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"channel-loading"},[_c('div',{class:['loader', { animate: _vm.animate }]})])}
var staticRenderFns = []

export { render, staticRenderFns }